import React from 'react';
import s from './PricingModal.module.css';
import DetailSection from '../../../pages/landing-page/pricing-page/DetailSection';
import { useSelector } from 'react-redux';
import { selectPricingModal } from '../../../store/selectors/pageSelectors';
import { setPricingModal } from '../../../store/slices/pageSlice';
import { useAppDispatch } from '../../../store/store';

const PricingModal = () => {
    const pricingModal = useSelector(selectPricingModal);
    const dispatch = useAppDispatch();

    const handleClose = () => {
        dispatch(setPricingModal(false));
    };

    if (!pricingModal) return null;

    return (
        <div className={s.modalOverlay} onClick={handleClose}>
            <div className={s.modal} onClick={(e) => e.stopPropagation()}>
                <DetailSection />
            </div>
        </div>
    );
};

export default PricingModal;
